import { isDefined } from "@clipboard-health/util-ts";
import { type LatenessConfigResponse } from "@src/appV2/ClipboardScore/api/useGetClipboardScoreProfile";

import { findLatenessConfigBasedOnMinutesLate } from "../../../../utils/getLatenessConfig";

interface GetPointsSavedWithLatenessCreditParams {
  latenessMinutes: number | undefined;
  latenessConfig: LatenessConfigResponse | undefined;
}

/**
 * Finds the matching lateness config for the given minutes late and calculates
 * how many points would be saved by applying a lateness credit.
 *
 * @returns The credit amount (positive number) or undefined if no match
 */
export function calculatePointsSavedWithLatenessCredit(
  params: GetPointsSavedWithLatenessCreditParams
): number | undefined {
  const { latenessMinutes, latenessConfig } = params;

  if (!isDefined(latenessMinutes) || !isDefined(latenessConfig) || latenessConfig.length === 0) {
    return undefined;
  }

  const matchingConfig = findLatenessConfigBasedOnMinutesLate(latenessMinutes, latenessConfig);

  if (!isDefined(matchingConfig) || !isDefined(matchingConfig.pointsWithEmergencyCredit)) {
    return undefined;
  }

  const penaltyPoints = Math.abs(matchingConfig.points);
  const creditPoints = Math.abs(matchingConfig.pointsWithEmergencyCredit);
  const savedPoints = penaltyPoints - creditPoints;

  return savedPoints > 0 ? savedPoints : undefined;
}
